import {BeneficiosPage} from './BeneficiosPage';
export default BeneficiosPage;
